import Lottie from 'lottie-react';

import lottieEnvironmentalFactors from '../jsons/environmental-factors.json';

const LottieEnvironmentalFactors = props => {
  return <Lottie animationData={lottieEnvironmentalFactors} loop={false} {...props} />;
};

export default LottieEnvironmentalFactors;
